var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('section',{staticClass:"bgImage"},[_c('v-img',{attrs:{"src":require("../assets/image-38-copyright-min.jpg")}})],1),_c('section',[_c('DJ')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }